import { useParams } from "react-router-dom";
import { routes, router } from "../../app/routes";
import { SlideOutModal, Submenu, SubmenuNavigationItem } from "../../components";
import { TubingService, UrlService, UserService } from "../../services";
import { useSharedState } from "../../app/sharedProperty";
import { Button } from "react-bootstrap";
import { showSuccessMessage, showErrorMessage } from "../../app/tools";
import { Roles } from "../../models";

export const TubingDetailsSubmenu = (props: any) => {
  const urlParams = useParams();
  const tubingId = UrlService.getParamValue("id", urlParams) ?? "0";
  const isAdmin = UserService.isInRole(Roles.admin);
  const params = new Map<string, string>();
  params.set("id", tubingId ?? "");

  const showSelectModalState = useSharedState(false);

  const selectModalCancelClick = () => {
    showSelectModalState.setter(false);
  };

  const deleteSelectClick = async () => {
    if(!isAdmin) {
      showErrorMessage(`You do not have permission to delete this tubing.`);
      showSelectModalState.setter(false);
      return;
    }
    try {
      await new TubingService().deleteTubing(parseInt(tubingId));
      showSuccessMessage(`Tubing successfully deleted.`);
      router.navigate(routes.tubings);
    }
    catch (error) {
      showErrorMessage(`Failed to delete tubing.`);
      console.error(error);
      showSelectModalState.setter(false);
      return;
    }
  };

  const submenu = [
    {
      label: "Back",
      url: routes.tubings,
      icon: "arrow-left",
    },
    {
      label: "Details",
      url: router.getUrl(routes.tubingDetails, new Map([["Id", tubingId]])),
      params,
      activeMatch: routes.tubingDetails,
    },
    {
      label: "Inspections",
      url: router.getUrl(routes.tubingInspections, new Map([["Id", tubingId]])),
      params,
      activeMatch: routes.tubingInspections,
    },
    {
      label: "Mill Cert",
      url: router.getUrl(routes.tubingMillCert, new Map([["Id", tubingId]])),
      params,
      activeMatch: routes.tubingMillCert,
    },
    isAdmin ? {
      label: "Delete",
      url: "",
      clickHandler: () => showSelectModalState.setter(true),
    } : null,
  ].filter(Boolean) as SubmenuNavigationItem[];

  return (
    <>
      <Submenu items={submenu} />
      <SlideOutModal
        showState={showSelectModalState}
        title={"Delete Tubing"}
        footer={
          <div className="row p-0 w-100">
            <div className="col-6 ps-0">
              <Button
                onClick={selectModalCancelClick}
                variant="cancel"
                className="w-100"
              >
                Cancel
              </Button>
            </div>
            <div className="col-6 pe-0">
              <Button
                onClick={deleteSelectClick}
                variant="primary"
                className="w-100"
              >
                Delete
              </Button>
            </div>
          </div>
        }
      >
        Are you sure you want to delete this tubing?
      </SlideOutModal>
    </>
  );
};

export default TubingDetailsSubmenu;

